(function () {
    'use strict';

    angular
        .module('directives.uiRouter', [])
        .directive('uiSrefIfPermission', directive);

    directive.$inject = ['$animate'];

    /**
     * Based on ng-if directive.
     * Can't be on the same element as an ng-if.
     */
    function directive($animate) {
        return {
            multiElement: true,
            transclude: 'element',
            priority: 600,
            terminal: true,
            restrict: 'A',
            $$tlb: true,
            link: function($scope, $element, $attr, ctrl, $transclude){
                $transclude(function(clone, newScope) {
                    $scope.childScope = newScope;
                    clone[clone.length++] = document.createComment(' end uiSrefIfPermission ');
                    $scope.block = { clone: clone };
                    $animate.enter(clone, $element.parent(), $element);
                });
            },
            controller: ['$scope', '$state', '$timeout', 'permissionService', function ($scope, $state, $timeout, permissionService) {
                this.hide = function(stateName) {
                    var state = $state.get(stateName);

                    if (state && state.data && state.data.permissions) {
                        if (!permissionService.hasPermissions(state.data.permissions)) {
                            $timeout(function() {
                                $scope.childScope.$destroy();
                                $scope.childScope = null;
                                $animate.leave(getBlockNodes($scope.block.clone));
                            });
                        }
                    }
                };

                /**
                 * Copy from angular
                 */
                function getBlockNodes(nodes) {
                    var node = nodes[0];
                    var endNode = nodes[nodes.length - 1];
                    var blockNodes = [node];

                    do {
                        node = node.nextSibling;
                        if (!node) break;
                        blockNodes.push(node);
                    } while (node !== endNode);

                    return angular.element(blockNodes);
                }
            }]
        };
    }

    // Add a ui-sref decorator to initialize ui-sref-if-permission
    angular
        .module('directives.uiRouter')
        .config(['$provide', function($provide) {
            $provide.decorator('uiSrefDirective', function($delegate) {
                var directive = $delegate[0];

                directive.require.push('?^uiSrefIfPermission');

                var link = directive.link;

                directive.compile = function() {
                    return function(scope, element, attrs, ctrls) {
                        if (ctrls[2]) {
                            // if uiSrefIfPermission parent directive exists, call "hide" method.
                            ctrls[2].hide(attrs.uiSref);
                        }

                        return link.apply(this, arguments);
                    };
                };

                return $delegate;
            });
        }]
    );

})();